import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import groupStyles from './group.module.css';
export var getStyles = function getStyles(size) {
  return mergeStyles(mainStyles, groupStyles, require("./size/".concat(size, ".module.css")));
};